import { useGlobals } from "../../hooks/useGlobals";
import { useTranslation } from "react-i18next";
import { MemberAuthType } from "../../lib/enums/member.enum";

function Profile() {
  const { t } = useTranslation();
  const { authMember } = useGlobals();

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        {t("profile.title")}
      </h2>
      <div className="space-y-6">
        {/* Profile Info */}
        <div className="flex items-center space-x-4">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-indigo-600 to-purple-600 flex items-center justify-center">
            {authMember?.memberImage ? (
              <img
                src={authMember.memberImage}
                alt={authMember.memberName}
                className="w-20 h-20 rounded-full object-cover"
              />
            ) : (
              <span className="text-white text-3xl font-bold">
                {authMember?.memberName
                  ?.split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase()
                  .slice(0, 2)}
              </span>
            )}
          </div>
          <div>
            <h3 className="text-xl font-semibold text-gray-900">
              {authMember?.memberName}
            </h3>
            <p className="text-gray-600">
              {authMember?.memberEmail &&
              authMember.memberAuthType !== MemberAuthType.TELEGRAM
                ? authMember?.memberEmail
                : `@${authMember?.memberUserName}`}
            </p>
          </div>
        </div>

        {/* Profile Details */}
        <div className="border-t pt-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("profile.fields.name")}
            </label>
            <div className="px-4 py-3 bg-gray-50 rounded-lg text-gray-900">
              {authMember?.memberName}
            </div>
          </div>
          {authMember?.memberEmail &&
          authMember.memberAuthType !== MemberAuthType.TELEGRAM ? (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("profile.fields.email")}
              </label>
              <div className="px-4 py-3 bg-gray-50 rounded-lg text-gray-900">
                {authMember?.memberEmail}
              </div>
            </div>
          ) : (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("profile.fields.username")}
              </label>
              <div className="px-4 py-3 bg-gray-50 rounded-lg text-gray-900">
                {authMember?.memberUserName ||
                  t("profile.fields.usernameNotAvailable")}
              </div>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("profile.fields.authType")}
            </label>
            <div className="px-4 py-3 bg-gray-50 rounded-lg text-gray-900">
              {authMember?.memberAuthType}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
